import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

const TermsOfService: React.FC = () => {
  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="Terms of Service — CodeRom"
        description="CodeRom terms of service. Read the terms governing your use of CodeRom."
      />
      <Navbar />

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 20px 60px'
      }}>
        {/* Breadcrumb */}
        <div style={{ marginBottom: '24px', fontSize: '14px' }}>
          <Link to="/" style={{ color: '#6366f1', textDecoration: 'none' }}>Home</Link>
          <span style={{ margin: '0 8px', color: '#9ca3af' }}>›</span>
          <span style={{ color: '#6b7280' }}>Terms of Service</span>
        </div>

        {/* Başlık kartı */}
        <div style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
          borderRadius: '16px',
          padding: '40px',
          marginBottom: '32px',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, margin: '0 0 8px' }}>Terms of Service</h1>
          <p style={{ fontSize: '14px', opacity: 0.8, margin: 0 }}>Last updated: April 2026 · Enerfix Limited</p>
        </div>

        {/* Ana içerik kartı */}
        <div style={{
          background: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '40px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>

          {/* Section 1 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: 0,
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              1. Agreement to terms
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              By accessing or using Coderom (operated by Enerfix Limited), you agree to be bound by these
              Terms of Service. If you do not agree, do not use our platform.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              2. Description of service
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Coderom is an e-commerce automation platform that helps sellers manage product listings, pricing,
              stock synchronisation, and order fulfilment across online marketplaces including eBay. The platform
              connects to your eBay and Amazon accounts via their official APIs.
            </p>
          </div>

          {/* Section 3 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              3. Account registration
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'You must be at least 18 years old',
                'You must provide accurate and complete information',
                'You are responsible for maintaining the security of your account',
                'You must not share your account credentials',
                'One person or business per account'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 4 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              4. Subscription and billing
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Subscription plans are billed monthly or annually',
                'Payments are processed via Stripe or PayPal',
                'Prices are in GBP and exclude VAT where applicable',
                'You can cancel your subscription at any time',
                'No refunds for partial billing periods unless required by law',
                'We reserve the right to change pricing with 30 days\' notice'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 5 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              5. Acceptable use
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              You agree not to:
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Use our platform for any illegal activity',
                'List counterfeit or prohibited products',
                'Violate eBay, Amazon, or any marketplace\'s terms of service',
                'Attempt to reverse-engineer or copy our software',
                'Use our platform to harm, abuse, or harass others',
                'Share your account with unauthorised users',
                'Exceed API rate limits or abuse our infrastructure'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#dc2626',
                    fontWeight: 'bold'
                  }}>✗</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 6 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              6. eBay and Amazon accounts
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'You are responsible for maintaining your eBay and Amazon accounts in good standing',
                'Coderom is not responsible for account suspensions by eBay or Amazon',
                'You authorise Coderom to interact with these platforms on your behalf via their APIs',
                'You remain responsible for all listings, orders, and customer interactions on these platforms'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 7 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              7. Intellectual property
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Coderom and all related software, designs, and content are owned by Enerfix Limited',
                'You may not copy, modify, or distribute our software',
                'Content you create using our platform (listings, descriptions) belongs to you'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 8 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              8. AI-generated content
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Coderom uses AI to generate product titles and descriptions',
                'You are responsible for reviewing and approving AI-generated content before publishing',
                'We do not guarantee that AI-generated content is free from errors'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 9 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              9. Limitation of liability
            </h2>
            <div style={{
              background: '#fef2f2',
              borderLeft: '4px solid #ef4444',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, lineHeight: '1.7' }}>
                <strong>Important:</strong> Coderom is provided "as is" without warranties. We are not liable for losses from marketplace changes, account suspensions, pricing errors, or sync delays. Our liability is limited to your 12-month subscription fee.
              </p>
            </div>
          </div>

          {/* Section 10 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              10. Indemnification
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              You agree to indemnify Enerfix Limited against any claims arising from your use of the platform,
              including violations of marketplace terms of service.
            </p>
          </div>

          {/* Section 11 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              11. Termination
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'You can close your account at any time',
                'We may suspend or terminate your account for violation of these terms',
                <>Upon termination, your data will be handled according to our <Link to="/privacy" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>Privacy Policy</Link></>
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 12 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              12. Governing law
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              These terms are governed by the laws of England and Wales. Any disputes will be subject to the
              exclusive jurisdiction of the courts of England and Wales.
            </p>
          </div>

          {/* Section 13 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              13. Changes to terms
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              We may update these terms with 30 days' notice. Continued use after changes constitutes acceptance.
            </p>
          </div>

          {/* Contact bölümü */}
          <div style={{
            background: '#f8fafc',
            borderRadius: '12px',
            padding: '24px',
            marginTop: '40px',
            textAlign: 'center'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1e1b4b', margin: '0 0 8px' }}>
              Questions about these terms?
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 16px' }}>
              Contact our team at <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a>
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              background: '#6366f1',
              color: 'white',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500
            }}>
              ← Back to Home
            </Link>
          </div>

        </div>
      </div>

      <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default TermsOfService;
